import { fetchOrders } from '../../../api/orders'

// initial state
const state = {
  ordersPages: [],
  orders: [],
  limit: 10,
  error: '',
  loading: false,
  countElements: 0
}

// getters
const getters = {
  orders: state => state.orders,
  error: state => state.error,
  loading: state => state.loading,
  countElements: state => state.countElements
}

// actions
const actions = {
  async fetchOrders ({ commit, state }, payload) {
    let page = payload.page
    let filterData = payload.filter
    let limit = state.limit
    let offset = (page - 1) * state.limit
    commit('loading', true)
    const data = await fetchOrders({offset, limit, filterData})
    commit('setOrdersPage', {orders: data.orders, page: page})
    commit('setCountElements', {count: data.count})
    commit('loading', false)
    commit('setPage', {page: page})
  }
}

// mutations
const mutations = {
  setOrdersPage (state, {orders, page}) {
    state.ordersPages[page - 1] = orders
  },
  setPage (state, {page}) {
    state.orders = state.ordersPages[[page - 1]]
  },
  loading (state, payload) {
    state.loading = payload
  },
  setCountElements (state, {count}) {
    state.countElements = count
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/store/modules/orders.js